import { useNavigate, useLocation } from "react-router-dom";
import { Mail, Users, Inbox, FileText, Send, BarChart3 } from "lucide-react";

const TABS = [
  { path: "/email", label: "Hub", icon: BarChart3, exact: true },
  { path: "/email/campaigns", label: "Campaigns", icon: Send },
  { path: "/email/contacts", label: "Contacts", icon: Users },
  { path: "/email/lists", label: "Lists", icon: Inbox },
  { path: "/email/templates", label: "Templates", icon: FileText },
];

export default function EmailNav() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="border-b border-border mb-6 -mx-4 md:-mx-6 px-4 md:px-6" data-testid="email-nav">
      <div className="flex items-center gap-2 mb-3">
        <Mail size={20} className="text-primary" />
        <h1 className="text-xl md:text-2xl font-outfit font-semibold">Email Marketing</h1>
      </div>
      <div className="flex gap-1 overflow-x-auto -mb-px">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = t.exact ? location.pathname === t.path : location.pathname.startsWith(t.path);
          return (
            <button
              key={t.path}
              data-testid={`email-tab-${t.label.toLowerCase()}`}
              onClick={() => navigate(t.path)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                active
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon size={15} />
              {t.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
